module.exports = __webpack_public_path__ + "img/headshot-annie-paz@1x.eb31b4ee.jpg";